import { createSlice } from '@reduxjs/toolkit'

import { getBestSellers, getNewProducts, getProductDetails, getProductOptions, getProducts, getSpecialProducts } from './actions'

export const initialState: any = {
  product: {
    data: [],
    options: [],
    loading: false,
    error: null,
  },
  productOptons: {
    data: [],
    loading: false,
    error: null,
  },
  productList: {
    data: [],
    meta: {},
    loading: false,
    error: null,
  },
  newProducts: {
    data: [],
    loading: false,
    error: null,
  },
  bestSellers: {
    data: [],
    loading: false,
    error: null,
  },
  specialProducts: {
    data: [],
    loading: false,
    error: null,
  },
}

const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getNewProducts.pending, state => {
      state.newProducts.loading = true
      state.newProducts.error = null
    })
    builder.addCase(getNewProducts.fulfilled, (state, { payload }) => {
      state.newProducts.loading = false
      state.newProducts.data = payload
    })
    builder.addCase(getNewProducts.rejected, (state, { payload }) => {
      state.newProducts.loading = false
      state.newProducts.error = payload as null
    })

    //
    builder.addCase(getProducts.pending, state => {
      state.productList.loading = true
      state.productList.error = null
    })
    builder.addCase(getProducts.fulfilled, (state, { payload }) => {
      state.productList.loading = false
      state.productList.data = payload.data
      state.productList.meta = payload.meta
    })
    builder.addCase(getProducts.rejected, (state, { payload }) => {
      state.productList.loading = false
      state.productList.error = payload as null
    })

    //
    builder.addCase(getProductDetails.pending, state => {
      state.product.loading = true
      state.product.error = null
    })
    builder.addCase(getProductDetails.fulfilled, (state, { payload }) => {
      state.product.loading = false
      state.product.data = payload
    })
    builder.addCase(getProductDetails.rejected, (state, { payload }) => {
      state.product.loading = false
      state.product.error = payload as null
    })

    //
    builder.addCase(getBestSellers.pending, state => {
      state.bestSellers.loading = true
      state.bestSellers.error = null
    })
    builder.addCase(getBestSellers.fulfilled, (state, { payload }) => {
      state.bestSellers.loading = false
      state.bestSellers.data = payload
    })
    builder.addCase(getBestSellers.rejected, (state, { payload }) => {
      state.bestSellers.loading = false
      state.bestSellers.error = payload as string
    })

    builder.addCase(getProductOptions.pending, state => {
      state.productOptons.loading = true
      state.productOptons.error = null
    })
    builder.addCase(getProductOptions.fulfilled, (state, { payload }) => {
      state.productOptons.loading = false
      state.productOptons.data = payload
    })
    builder.addCase(getProductOptions.rejected, (state, { payload }) => {
      state.productOptons.loading = false
      state.productOptons.error = payload as null
    })
    builder.addCase(getSpecialProducts.pending, state => {
      state.specialProducts.loading = true
      state.specialProducts.error = null
    })
    builder.addCase(getSpecialProducts.fulfilled, (state, { payload }) => {
      state.specialProducts.loading = false
      state.specialProducts.data = payload
    })
    builder.addCase(getSpecialProducts.rejected, (state, { payload }) => {
      state.specialProducts.loading = false
      state.specialProducts.error = payload as string
    })
  },
})

export const { name, actions } = productSlice

const productReducer = productSlice.reducer

export default productReducer
